export type AppUIFont = 'inter' | 'geist' | 'plus-jakarta';

export const APP_UI_FONT_STORAGE_KEY = 'netprobuilder-app-ui-font';

const FALLBACK =
  "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif";

const FONT_STACKS: Record<AppUIFont, string> = {
  inter: `'Inter', ${FALLBACK}`,
  geist: `'Geist', ${FALLBACK}`,
  'plus-jakarta': `'Plus Jakarta Sans', ${FALLBACK}`,
};

export function readStoredAppUIFont(): AppUIFont {
  try {
    const raw = localStorage.getItem(APP_UI_FONT_STORAGE_KEY);
    if (raw === 'geist' || raw === 'plus-jakarta') return raw;
  } catch {
    /* ignore */
  }
  return 'inter';
}

export function applyAppUIFont(font: AppUIFont): void {
  const stack = FONT_STACKS[font] ?? FONT_STACKS.inter;
  document.documentElement.style.setProperty('--app-font-sans', stack);
}

export function persistAppUIFont(font: AppUIFont): void {
  try {
    localStorage.setItem(APP_UI_FONT_STORAGE_KEY, font);
  } catch {
    /* ignore */
  }
}
